const ICON_COUNT = 11;

export function productPlaceholderIcon(productId: number): string {
  const n = (Math.abs(productId) % ICON_COUNT) + 1;
  return `/images/categories/icon-${n}.webp`;
}
